import r2wc from "@r2wc/react-to-web-component";
import { DateRangeInput } from "@fm/ui";

const DateRangeInputWebComponent = r2wc(DateRangeInput, {
  props: {
    value: "json",
    placeholder: "string",
    format: "string",
    theme: "string",
    disabled: "boolean",
    minDate: "string",
    maxDate: "string",
    unavailableDates: "json",
    className: "string",
    error: "string",
    showLabels: "boolean",
    startLabel: "string",
    endLabel: "string",
    showToday: "boolean",
    // Legacy props
    startDate: "string",
    endDate: "string",
  },
  events: {
    onChange: { bubbles: true, composed: true },
    onDateRangeChange: { bubbles: true, composed: true },
  },
});

if (!customElements.get("fm-date-range-input")) {
  customElements.define("fm-date-range-input", DateRangeInputWebComponent);
}
